







































import {Component, Prop, Vue} from "vue-property-decorator";

;
import {Portfolio} from "@/types/index";
import {dateFormat} from "@/script/moment";

@Component({
    components: {},
})
export default class PortfolioCard extends Vue {
    @Prop() portfolio!: Portfolio;

    private latestDate: string = "";

    mounted() {
        this.latestDate = dateFormat(this.portfolio.latest_update!);
    }
}
